import React from 'react';
import { Redirect } from 'react-router';

import { locationsURL } from './routes';

export const Neighborhood = () => {
  return <Redirect to={locationsURL()} />;
};
